export const TOKEN_TYPE_KEY = 'tokenType';
export const CLIENT_COOKIE_TOKEN_GETTER = 'fincrm_client_token';
export const TOKEN_GETTER_KEY = 'authToken';
export enum TokenType {
  EXPERT = 'expert',
  CLIENT = 'client',
}
